import { getExternalAccountReach } from '@shared/locations'
import { captureError } from '@shared/monitoring'
import type { LocationClientDto } from 'service-api/src/types/api'

export const injectReachScript = (location: LocationClientDto) => {
  try {
    if (document.getElementById('embedreach')) return

    const reachKey = getExternalAccountReach(location)
    if (!reachKey) return

    const script = document.createElement('script')
    script.src = `https://public.embedreach.com/scripts/26ac5e882814/${reachKey}/analytics.js`
    script.async = true
    script.id = 'embedreach'
    script.type = 'text/javascript'

    document.body.appendChild(script)
  } catch (error) {
    captureError({ cause: error } as Error)
  }
}
